// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export enum Direction {
  /**
   * Represents an object located or facing in the down (z - 1)
   * direction.
   */
  down = 0,
  /**
   * Represents an object located or facing in the up (z + 1)
   * direction.
   */
  up = 1,
  /**
   * Represents an object located or facing in the north (z - 1)
   * direction.
   */
  north = 2,
  /**
   * Represents an object located or facing in the south (z + 1)
   * direction.
   */
  south = 3,
  /**
   * Represents an object located or facing in the west (x - 1)
   * direction.
   */
  west = 4,
  /**
   * Represents an object located or facing in the east (x + 1)
   * direction.
   */
  east = 5,
}
